import Alerta from "../../components/alerta/Alerta";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import style from "./Aviso.module.css";
import Loader from "../../components/loader/Loader";
import AvisoApi from "../../services/AvisoApi";
import { MdClose, MdDelete, MdSearch } from "react-icons/md";
import Paginacao from "../../components/paginacao/Paginacao";
import ValidarPermissao from "../../services/ValidarPermissao";
import UsuarioApi from "../../services/UsuarioApi";
import { TiDelete } from "react-icons/ti";
import { IoEyeSharp } from "react-icons/io5";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import PessoaTurmaApi from "../../services/PessoaTurmaApi";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import FuncionalidadesNome from "../../constants/FuncionalidadesNome";

function Aviso() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    const mostrarModalMonitor =
        ValidarPermissao.validar(
            FuncionalidadesNome.ModalAdicionarAvisosMonitor
        );

    const mostrarModalCoordenador =
        ValidarPermissao.validar(
            FuncionalidadesNome.ModalAdicionarAvisosCoordenador
        );
    const [turmas, setTurmas] = useState([]);
    const [turmasSelecionadas, setTurmasSelecionadas] = useState([]);
    const [alunos, setAlunos] = useState([]);
    const [monitores, setMonitores] = useState([]);
    const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState('');
    const [tipoAlerta, setTipoAlerta] = useState('');
    const [search, setSearch] = useState('');
    const [filtroModalAdicionar, setFiltroModalAdicionar] = useState('');
    const [mostrarModal, setMostrarModal] = useState(false);
    const [adicionar, setAdicionar] = useState(false);
    const [remover, setRemover] = useState(false);
    const [avisoVisualizar, setAvisoVisualizar] = useState(null);
    const [visualizar, setVisualizar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [avisoSelecionado, setAvisoSelecionado] = useState(null);
    const [avisoId, setAvisoId] = useState(null);
    const [tipoAvisoEnum, setTipoAvisoEnum] = useState(null);
    const [tiposAvisoCoordenadorEnum, setTiposAvisoCoordenadorEnum] = useState([
        { key: 1, value: "Enviar aviso para todos os monitores." },
        { key: 2, value: "Enviar aviso para um ou mais monitores específicos." }
    ]);

    //Para rodar a tabela, paginação e filtro
    const [avisos, setAvisos] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [titulo, setTitulo] = useState("");
    const [descricao, setDescricao] = useState("");
    const [tituloFiltro, setTituloFiltro] = useState("");
    const [descricaoFiltro, setDescricaoFiltro] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);

    const [tiposAvisoMonitorEnum, setTiposAvisoMonitorEnum] = useState([
        { key: 3, value: "Enviar aviso para todas as turmas." },
        { key: 4, value: "Enviar aviso para uma ou mais turmas." },
        { key: 10, value: "Enviar aviso para um ou mais alunos vinculados às turmas." }
    ]);

    const [novoTitulo, setNovoTitulo] = useState("");
    const [novaDescricao, setNovaDescricao] = useState("");

    const [grupoDeUsuarios, setGrupoDeUsuarios] = useState([]);
    const [itensPorPagina] = useState(10); // Define o número de itens por página

    const filtrarAvisos = () => {
        return avisos.filter(
            (Aviso) =>
                Aviso.titulo.toLowerCase().includes(search.toLowerCase()) ||
                Aviso.dataCriacao.toLowerCase().includes(search.toLowerCase())
        );
    };

    // Função para calcular os itens da página atual
    const obterItensDaPaginaAtual = (avisosFiltrados) => {
        const indicedoultimoitem = paginaAtual * itensPorPagina;
        const indicedoprimeiroitem = indicedoultimoitem - itensPorPagina;
        return avisosFiltrados.slice(indicedoprimeiroitem, indicedoultimoitem);
    };

    // Função para calcular o total de páginas 
    const calcularTotalDePaginas = (avisosFiltrados) => {
        return Math.ceil(avisosFiltrados.length / itensPorPagina);
    };

    const avisosFiltrados = filtrarAvisos();
    const itensPaginaAtual = obterItensDaPaginaAtual(avisosFiltrados);
    const totalPages = calcularTotalDePaginas(avisosFiltrados);

    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    async function BuscarAvisos() {
        setTitulo(tituloFiltro);
        setDescricao(descricaoFiltro);
        setPaginaAtual(1);
        obterAvisos();
    }

    //Função para resetar  filtro de busca
    async function ResetarAvisos() {
        setTitulo("");
        setDescricao("");
        setTituloFiltro("");
        setDescricaoFiltro("");
        setPaginaAtual(1);
        obterAvisos();
    }

    const FecharModal = () => {
        setMostrarModal(false);
        setAvisoSelecionado(null);
        setRemover(false);
        setAdicionar(false);
        setVisualizar(false);
        setAvisoId(null)
        setAvisoVisualizar(null);
        setTitulo(null);
        setNovoTitulo(null);
        setNovaDescricao(null);
        setDescricao(null);
        setTipoAvisoEnum(null);
        setTurmasSelecionadas([]);
    };

    async function modalVisualizar(Aviso) {

        setAvisoSelecionado(Aviso);
        setAvisoId(Aviso.avisoID);
        const aviso = await AvisoApi.VisualizarAvisoAsync(Aviso.avisoID);
        setAvisoVisualizar(aviso);
        setVisualizar(true);
        setMostrarModal(true);

    }

    function modalExcluir(Aviso) {
        setLoading(true);
        setAvisoSelecionado(Aviso);
        setAvisoId(Aviso.avisoID)
        setRemover(true);
        setMostrarModal(true);
        setLoading(false);
    }

    async function excluirAviso() {
        try {
            setLoading(true);
            await AvisoApi.RemoverAvisoAsync(avisoId);
            obterAvisos();
            setMensagemAlerta(`Aviso excluido com sucesso!`);
            setTipoAlerta('success');
        }
        catch (error) {
            setMensagemAlerta(`Erro ao excluir a Aviso: ${error.response.data}`);
            setTipoAlerta('danger');
        }
        finally {
            FecharModal();
            setLoading(false);
            exibirAlerta();
        }
    }

    function modalAdicionar() {
        setLoading(true);
        setAdicionar(true);
        setUsuariosSelecionados([]);
        setMostrarModal(true);
        setLoading(false);
    }

    async function adicionarAviso() {
        try {
            setLoading(true);
            await AvisoApi.CriarAvisoAsync(novoTitulo, novaDescricao, tipoAvisoEnum, usuariosSelecionados);
            obterAvisos()
            setMensagemAlerta(`Aviso adicionado com sucesso!`);
            setTipoAlerta('success');
        }
        catch (error) {
            setMensagemAlerta(`Erro ao adicionar o Aviso: ${error.response.data}`);
            setTipoAlerta('danger');
        }
        finally {
            FecharModal();
            setLoading(false);
            exibirAlerta();
        }
    }

    async function obterAvisos() {
        try {
            const listaAvisos = await AvisoApi.ObterTodosAvisosAsync(paginaAtual, titulo, descricao);
            setQuantidadeItens(listaAvisos.quantidadeRegistros);
            setAvisos(listaAvisos.registros);
        } catch (error) {
            setMensagemAlerta(`Erro ao listar os avisos: ${error.response.data}`);
            setTipoAlerta('danger');
            exibirAlerta();
        }
    }

    async function ObterMonitoresAsync() {
        const resposta = await UsuarioApi.ListarUsuariosPorGrupoDeUsuarioAsync(3);
        setMonitores(resposta);
    }

    async function ObterTurmas() {
        const resposta = await PessoaTurmaApi.listarTurmasPorPessoaAsync();
        setTurmas(resposta);
    }

    async function ObterUsuariosDaTurma() {
        const resposta = await UsuarioApi.ObterIdsUsuariosDasTurmas(turmasSelecionadas);
        setUsuariosSelecionados(resposta);
    }

    async function ListarUsuariosAlunosVinculadosAoMonitor() {
        const resposta = await UsuarioApi.ListarUsuariosAlunosVinculadosAoMonitor();
        setAlunos(resposta);
    }

    useEffect(() => {
        setLoading(true);
        obterAvisos();

        if (mostrarModalCoordenador) {
            ObterMonitoresAsync();
        }

        if (mostrarModalMonitor) {
            ObterTurmas();
            ListarUsuariosAlunosVinculadosAoMonitor();
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        setLoading(true);

        if (mostrarModalMonitor) {
            ObterUsuariosDaTurma();
        }

        setLoading(false);
    }, [turmasSelecionadas]);

    useEffect(() => {
        obterAvisos();
    }, [paginaAtual, titulo, descricao]);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}

                <div className={style.pagina_conteudo}>
                    {/* Cabeçalho da pagina */}
                    <div className={style.container_cabecalho}>
                        <h4>Avisos</h4>
                        <BotaoNovo link={modalAdicionar} />
                    </div>

                    {/* Barra de pesquisa */}
                    <div className={style.container_filtro}>
                        <InputBuscar
                            type="text"
                            id="hidenTitulo"
                            placeholder="Título"
                            name="titulo"
                            value={tituloFiltro}
                            maxLength={30}
                            onChange={(e) => setTituloFiltro(e.target.value)}
                        />

                        <InputBuscar
                            type="text"
                            id="hidenDescricao"
                            placeholder="Descrição"
                            name="descricao"
                            value={descricaoFiltro}
                            maxLength={50}
                            onChange={(e) => setDescricaoFiltro(e.target.value)}
                        />
                        <div className={style.container_filtro2}>
                            <Button onClick={BuscarAvisos} id={style.botao_buscar}><MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarAvisos} id={style.botao_resetar}><MdClose /> Limpar
                            </Button>
                        </div>

                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Título</th>
                                        <th>Mensagem</th>
                                        <th>Data Criação</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itensPaginaAtual.map((aviso) => (
                                        <tr className={style.tabela_corpo} key={aviso.avisoID}>
                                            <td title={aviso.titulo}>{aviso.titulo}</td>
                                            <td title={aviso.descricao}>{aviso.descricao}</td>
                                            <td title={new Date(aviso.dataCriacao).toLocaleString("pt-BR")}>{new Date(aviso.dataCriacao).toLocaleString("pt-BR")}</td>
                                            <td className={style.coluna_acoes}>
                                                <Link onClick={() => modalVisualizar(aviso)} className={style.botao_visualizar}><IoEyeSharp
                                                    title="Visualizar" />
                                                </Link>
                                                <Link onClick={() => modalExcluir(aviso)} className={style.botao_deletar}>
                                                    <MdDelete
                                                        title="Deletar" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Controle de Paginação */}
                        <Paginacao
                            paginaAtual={paginaAtual}
                            totalPages={totalPages}
                            onPageChange={(novaPagina) => setPaginaAtual(novaPagina)}
                        />
                    </div>

                    {/* Modal de confirmação */}
                    <Modal show={mostrarModal} onHide={FecharModal}>
                        {adicionar && mostrarModalCoordenador && (<>
                            <Modal.Header closeButton>
                                <Modal.Title>Enviar aviso</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Título</Form.Label>
                                    <InputBuscar maxLength={100} type="text" placeholder="Título" name="titulo" value={novoTitulo} onChange={(e) => setNovoTitulo(e.target.value)} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <textarea maxLength={250} className={`form-control ${style.areaInput}`} rows='3' type="text" placeholder="Descrição" name="descricao" value={novaDescricao} onChange={(e) => setNovaDescricao(e.target.value)} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de Aviso</Form.Label>
                                    {tiposAvisoCoordenadorEnum.map((tipo) => (
                                        <Form.Check
                                            key={tipo.key}
                                            type="radio"
                                            label={tipo.value}
                                            name="tipoAviso"
                                            checked={tipoAvisoEnum === tipo.key}
                                            onChange={() => setTipoAvisoEnum(tipo.key)}
                                        />
                                    ))}
                                </Form.Group>

                                {tipoAvisoEnum === 2 && (
                                    <>
                                        <Form.Group controlId="formUsuarios" className="mb-3">
                                            <Form.Label>Selecione os Monitores</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={usuariosSelecionados[0] || ""}  // Mantém o valor selecionado
                                                onChange={(e) => {
                                                    const selectedValue = Number(e.target.value); // Converte o valor para número
                                                    if (selectedValue && !usuariosSelecionados.includes(selectedValue)) {
                                                        setUsuariosSelecionados([...usuariosSelecionados, selectedValue]); // Adiciona o monitor selecionado
                                                    }
                                                }}
                                            >
                                                <option value="">Selecione um Monitor</option>
                                                {monitores.filter(monitor => !usuariosSelecionados.includes(monitor.id))  // Filtra os selecionados
                                                    .map((monitor) => (
                                                        <option key={monitor.id} value={monitor.id}>
                                                            {monitor.nome}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <div className={style.usuariosSelecionados}>
                                            {usuariosSelecionados.map((usuarioId) => {
                                                const usuario = monitores.find(m => m.id === Number(usuarioId));

                                                return usuario ? (
                                                    <span key={usuario.id} className={style.usuarioTag}>
                                                        <p>{usuario.nome}</p>
                                                        <button
                                                            className={style.removerUsuario}
                                                            onClick={() => setUsuariosSelecionados(usuariosSelecionados.filter(id => id !== usuario.id))}
                                                        >
                                                            <TiDelete
                                                                title="Deletar" size={20} />
                                                        </button>
                                                    </span>
                                                ) : null;
                                            })}
                                        </div>
                                    </>
                                )}

                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary " onClick={FecharModal}>
                                    Cancelar
                                </Button>

                                <Button variant="success" onClick={adicionarAviso}>
                                    Enviar
                                </Button>
                            </Modal.Footer>
                        </>)}

                        {adicionar && mostrarModalMonitor && (<>
                            <Modal.Header closeButton>
                                <Modal.Title>Enviar aviso</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Título</Form.Label>
                                    <InputBuscar maxLength={100} type="text" placeholder="Título" name="titulo" value={novoTitulo} onChange={(e) => setNovoTitulo(e.target.value)} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <textarea maxLength={250} className={`form-control ${style.areaInput}`} rows='3' type="text" placeholder="Descrição" name="descricao" value={novaDescricao} onChange={(e) => setNovaDescricao(e.target.value)} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de Aviso</Form.Label>
                                    {tiposAvisoMonitorEnum.map((tipo) => (
                                        <Form.Check
                                            key={tipo.key}
                                            type="radio"
                                            label={tipo.value}
                                            name="tipoAviso"
                                            checked={tipoAvisoEnum === tipo.key}
                                            onChange={() => setTipoAvisoEnum(tipo.key)}
                                        />
                                    ))}
                                </Form.Group>
                                {tipoAvisoEnum === 4 && (
                                    <>
                                        <Form.Group controlId="formTurmas" className="mb-3">
                                            <Form.Label>Selecione as turmas</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value="" // Deixa vazio pra permitir múltiplas seleções
                                                onChange={(e) => {
                                                    const selectedValue = Number(e.target.value);
                                                    if (selectedValue && !turmasSelecionadas.includes(selectedValue)) {
                                                        setTurmasSelecionadas([...turmasSelecionadas, selectedValue]);
                                                    }
                                                }}
                                            >
                                                <option value="">Selecione uma turma</option>
                                                {turmas
                                                    .filter(turma => !turmasSelecionadas.includes(turma.turmaId))
                                                    .map((turma) => (
                                                        <option key={turma.turmaId} value={turma.turmaId}>
                                                            {turma.nome}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <div className={style.usuariosSelecionados}>
                                            {turmasSelecionadas.map((turmaId) => {
                                                const turma = turmas.find(t => t.turmaId === turmaId);
                                                return turma ? (
                                                    <span key={turma.turmaId} className={style.usuarioTag}>
                                                        <p>{turma.nome}</p>
                                                        <button
                                                            className={style.removerUsuario}
                                                            onClick={() => setTurmasSelecionadas(
                                                                turmasSelecionadas.filter(id => id !== turma.turmaId)
                                                            )}
                                                        >
                                                            <TiDelete size={20} />
                                                        </button>
                                                    </span>
                                                ) : null;
                                            })}
                                        </div>
                                    </>
                                )}
                                {tipoAvisoEnum === 10 && (
                                    <>
                                        <Form.Group controlId="formUsuarios" className="mb-3">
                                            <Form.Label>Selecione os alunos</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={usuariosSelecionados[0] || ""}  // Mantém o valor selecionado
                                                onChange={(e) => {
                                                    const selectedValue = Number(e.target.value); // Converte o valor para número
                                                    if (selectedValue && !usuariosSelecionados.includes(selectedValue)) {
                                                        setUsuariosSelecionados([...usuariosSelecionados, selectedValue]); // Adiciona o monitor selecionado
                                                    }
                                                }}
                                            >
                                                <option value="">Selecione um aluno</option>
                                                {alunos.filter(aluno => !usuariosSelecionados.includes(aluno.id))  // Filtra os selecionados
                                                    .map((aluno) => (
                                                        <option key={aluno.id} value={aluno.id}>
                                                            {aluno.nomeCompleto}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <div className={style.usuariosSelecionados}>
                                            {usuariosSelecionados.map((usuarioId) => {
                                                const usuario = alunos.find(a => a.id === Number(usuarioId));

                                                return usuario ? (
                                                    <span key={usuario.id} className={style.usuarioTag}>
                                                        <p>{usuario.nomeCompleto}</p>
                                                        <button
                                                            className={style.removerUsuario}
                                                            onClick={() => setUsuariosSelecionados(usuariosSelecionados.filter(id => id !== usuario.id))}
                                                        >
                                                            <TiDelete size={20} />
                                                        </button>
                                                    </span>
                                                ) : null;
                                            })}
                                        </div>
                                    </>
                                )}
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary" onClick={FecharModal}>
                                    Cancelar
                                </Button>

                                <Button variant="success" onClick={adicionarAviso}>
                                    Enviar
                                </Button>
                            </Modal.Footer>
                        </>)}

                        {visualizar ? (
                            <>
                                <Modal.Header closeButton>
                                    <Modal.Title>Visualizar Aviso</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Título</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={avisoVisualizar.titulo}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={avisoVisualizar.descricao}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Data de Envio</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={new Date(avisoVisualizar.dataCriacao).toLocaleString("pt-BR")}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>

                                    {/* Exibir os usuários que foram notificados */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuários Notificados</Form.Label>
                                        <div className={style.usuariosSelecionados}>
                                            {avisoVisualizar.nomes.map((nome, index) => (
                                                <span key={index} className={style.usuarioTag}>
                                                    <p>{nome}</p>
                                                </span>
                                            ))}
                                        </div>
                                    </Form.Group>
                                </Modal.Body>
                            </>
                        ) : null}

                        {remover ? <>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmar</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                Tem certeza que deseja remover o aviso {avisoSelecionado?.nome}?
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary " onClick={FecharModal}>
                                    Cancelar
                                </Button>

                                <Button variant="danger" onClick={excluirAviso}>
                                    Deletar
                                </Button>
                            </Modal.Footer>
                        </>
                            : null}
                    </Modal>
                </div>
            </Topbar>
        </Sidebar >
    );
}

export default Aviso;